console.log('[lpr] script loaded');
const STORAGE_KEY = 'kandyQuizAnswers';
const QUIZ_URL = '/pages/longevity-plan-quiz';
const RESULTS_URL = '/pages/longevity-plan-quiz-results';
// Same ?qa= payload as the results page, but the page there adds to cart on load and redirects
// to checkout instead of rendering the plan. Built for Klaviyo emails — see buildCheckoutLink.
const CHECKOUT_URL = '/pages/longevity-plan-checkout';

// null = required (missing → retake quiz). Any other value = default to use.
const QUIZ_FIELD_DEFAULTS = {
  name:     null,
  gender:   null,
  weight:   null,
  email:    null,
  neutered: 'no',
  allergies: [],
  age:      'adult',
  activity: 'moderate',
  appetite: 'depends',
  goal:     'wellbeing',
};

function backfillAnswers(decoded) {
  const result = { ...decoded, isCompleted: true };
  for (const [key, defaultValue] of Object.entries(QUIZ_FIELD_DEFAULTS)) {
    const val = result[key];
    if (val === undefined || val === null || val === '') {
      if (defaultValue === null) return null;
      result[key] = defaultValue;
    }
  }
  return result;
}
const STOREFRONT_API_VERSION = '2026-01';
const LOOP_SELLING_PLAN = 711241630069;
const DEFAULT_DISCOUNT_CODE = 'LONGEVITY20';

// Campaign codes outside the LONGEVITY<n> family. Every other code in this flow encodes its own
// percent in its name (LONGEVITY20 -> 20%); these can't, so the percent is declared here instead.
// An explicit allowlist means an arbitrary code can never grant a discount by accident.
//   key   = ASCII-folded, uppercased form used for matching
//   code  = the string sent to Shopify — it MUST match the discount code in Admin character for
//           character, or the page shows -25% while checkout charges the undiscounted price.
const CAMPAIGN_DISCOUNTS = {
  FINDE25:  { code: 'FINDE25',  percent: 25 },
  PROMO25:  { code: 'PROMO25',  percent: 25 },
};

function normaliseCode(code) {
  return (code || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
}

function campaignDiscount(code) {
  return CAMPAIGN_DISCOUNTS[normaliseCode(code)] || null;
}

// 0 for anything unrecognised, so an unknown code can never displace a real one.
function discountPercentOf(code) {
  const campaign = campaignDiscount(code);
  if (campaign) return campaign.percent;
  const match = /^LONGEVITY(\d+)$/.exec((code || '').toUpperCase());
  return match ? parseInt(match[1], 10) : 0;
}

function isKnownDiscountCode(code) {
  return discountPercentOf(code) > 0;
}

// The exact string to hand Shopify — campaign codes resolve back to their canonical spelling.
function canonicalCode(code) {
  const campaign = campaignDiscount(code);
  return campaign ? campaign.code : (code || '').toUpperCase();
}

const TOPPING_VARIANTS = [
  { id: 57213630022005, quantity: 1 },
];

const FRESH_VARIANT_MAP = [
  { maxKg: 1,        trialId: 57137817977205, ongoingId: 57545574449525 },
  { maxKg: 3,        trialId: 57137818009973, ongoingId: 57545574482293 },
  { maxKg: 5,        trialId: 57137818042741, ongoingId: 57545574515061 },
  { maxKg: 7,        trialId: 57137818075509, ongoingId: 57545574547829 },
  { maxKg: 9,        trialId: 57137818108277, ongoingId: 57545574580597 },
  { maxKg: 13,       trialId: 57137818141045, ongoingId: 57545574613365 },
  { maxKg: 21,       trialId: 57137818173813, ongoingId: 57545574646133 },
  { maxKg: 25,       trialId: 57137818206581, ongoingId: 57545574678901 },
  { maxKg: 31,       trialId: 57137818239349, ongoingId: 57545574711669 },
  { maxKg: 37,       trialId: 57137818272117, ongoingId: 57545574744437 },
  { maxKg: 44,       trialId: 57137818304885, ongoingId: 57545574777205 },
  { maxKg: 50,       trialId: 57137818337653, ongoingId: 57545574809973 },
  { maxKg: 58,       trialId: 57137818370421, ongoingId: 57545574842741 },
  { maxKg: 65,       trialId: 57137818403189, ongoingId: 57545574875509 },
  { maxKg: 72,       trialId: 57137818435957, ongoingId: 57545574908277 },
  { maxKg: 80,       trialId: 57137818468725, ongoingId: 57545574941045 },
  { maxKg: 88,       trialId: 57137818501493, ongoingId: 57545574973813 },
  { maxKg: Infinity, trialId: 57137818534261, ongoingId: 57545575006581 },
];

function setDiscountIfBetter(code) {
  const incoming = code.toUpperCase();
  const existing = localStorage.getItem('longevityDiscountCode') || '';
  if (discountPercentOf(incoming) >= discountPercentOf(existing)) {
    localStorage.setItem('longevityDiscountCode', incoming);
  }
}

function getActiveDiscount(cartCode, answers) {
  const candidates = [
    (cartCode || '').toUpperCase(),
    (localStorage.getItem('longevityDiscountCode') || '').toUpperCase(),
    ((answers && answers.discountCode) || '').toUpperCase(),
  ].filter(c => isKnownDiscountCode(c));

  if (candidates.length > 0) {
    const best = candidates.reduce((a, b) =>
      discountPercentOf(a) >= discountPercentOf(b) ? a : b
    );
    return { percent: discountPercentOf(best), code: canonicalCode(best) };
  }
  return { percent: window.__lprDiscount ?? 20, code: DEFAULT_DISCOUNT_CODE };
}

function loadAnswers() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const item = JSON.parse(raw);
    if (Date.now() > item.expiry) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return item.value || null;
  } catch (e) {
    return null;
  }
}

function getFreshTier(weightKg) {
  const w = parseFloat(weightKg);
  if (!w || w <= 0) return FRESH_VARIANT_MAP[0];
  return FRESH_VARIANT_MAP.find(t => w <= t.maxKg) || FRESH_VARIANT_MAP[FRESH_VARIANT_MAP.length - 1];
}

// Shopify applies a percentage code as an AMOUNT and truncates it to the cent, so the price it
// charges is the next cent up from price × (1 - pct): 27,98 - floor(2,798) = 25,19, where
// Math.round would have shown 25,18. Mirroring that here keeps the page from ever quoting less
// than the checkout takes. Verified against a live checkout on 2026-09-09 (25,18 vs 25,19).
function discounted(cents, pct) {
  return cents - Math.floor((cents * pct) / 100);
}

function formatMoney(cents) {
  return '€' + (cents / 100).toFixed(2).replace('.', ',');
}

function calcPortionGrams(weightKg) {
  const w = parseFloat(weightKg);
  if (!w || w <= 0) return 250;
  return Math.round(w * 25);
}

function formatGrams(g) {
  return g >= 1000 ? `${(g / 1000).toFixed(1).replace('.0', '')}kg` : `${g}g`;
}

function fillName(answers) {
  const name = answers.name || 'tu perro';
  document.querySelectorAll('[data-lpr-name]').forEach(el => {
    el.textContent = name;
  });
}

function fillPortion(answers) {
  const grams = calcPortionGrams(answers.weight);
  const toppingGrams = Math.round(grams * 0.4 / 5) * 5;
  const priceMap = window.__lprPriceMap || {};
  const tier = getFreshTier(answers.weight);
  const trialEntry = priceMap[tier.trialId] ?? priceMap[String(tier.trialId)];
  const portionText = trialEntry?.title || formatGrams(grams);
  document.querySelectorAll('[data-lpr-portion]').forEach(el => {
    el.textContent = portionText;
  });
  document.querySelectorAll('[data-lpr-topping-amount]').forEach(el => {
    el.textContent = formatGrams(toppingGrams);
  });
}

function fillFreshAccordions() {
  const wrapper = document.querySelector('[data-lpr-recipe-content]');
  if (!wrapper) return;

  const content = window.__lprFreshContent || {};
  wrapper.hidden = false;

  const compositionEl = document.querySelector('.lpr-accordion--composition .accordion__body');
  if (compositionEl) compositionEl.textContent = content.composition || '';

  const nutritionalEl = document.querySelector('.lpr-accordion--nutritional .accordion__body');
  if (nutritionalEl) nutritionalEl.textContent = content.nutritionalValues || '';

  const storageEl = document.querySelector('.lpr-accordion--additives .accordion__body');
  if (storageEl) storageEl.textContent = content.storageUse || '';
}

// The amount carries the emphasis; the duration next to it stays quiet, so the line reads as one
// price and not as two competing numbers. Both values are formatted here, never user input.
function writeTotal(el, cents, days) {
  el.innerHTML =
    `${formatMoney(cents)} <span class="lpr-pricing-row__total-note">· ${days} días</span>`;
}

// The pricing row keeps the per-day figure as the headline number — it is the lowest and most
// comparable price on the page — and adds the full amount charged on a second line below it, so
// the total is never a surprise at checkout. The per-day figure is derived FROM the total
// (total ÷ days) rather than the total from a rounded per-day rate: with both numbers on screen,
// per-day × days must land back on the total, otherwise the pair reads as a mistake.
function fillPrices(answers) {
  const priceMap = window.__lprPriceMap || {};
  const trialDays = window.__lprTrialDays || 15;
  const discountPct = window.__lprDiscount ?? 20;
  const tier = getFreshTier(answers.weight);

  const trialEntry = priceMap[tier.trialId] ?? priceMap[String(tier.trialId)];
  if (trialEntry != null) {
    // subscriptionPrice = selling-plan first-order price; price = recurring rate (used as compare-at).
    // The discount code applies to the cart total, so discount the total and divide, not the reverse.
    const fullTotal = trialEntry.subscriptionPrice;
    const discTotal = discountPct > 0 ? discounted(fullTotal, discountPct) : null;
    const fullEl = document.querySelector('[data-lpr-price="trial-full"]');
    const discEl = document.querySelector('[data-lpr-price="trial-disc"]');
    const totalEl = document.querySelector('[data-lpr-total="trial"]');
    if (discTotal !== null) {
      if (fullEl) fullEl.textContent = formatMoney(Math.round(fullTotal / trialDays));
      if (discEl) discEl.textContent = formatMoney(Math.round(discTotal / trialDays));
      if (totalEl) writeTotal(totalEl, discTotal, trialDays);
    } else {
      if (fullEl) fullEl.style.display = 'none';
      if (discEl) discEl.textContent = formatMoney(Math.round(fullTotal / trialDays));
      if (totalEl) writeTotal(totalEl, fullTotal, trialDays);
    }
  } else {
    console.warn('[lpr] trial price not found for variantId:', tier.trialId);
  }

  // The monthly row is no longer rendered in the pricing bar, but the ongoing variant is still
  // resolved for the Klaviyo lp_ongoing_price_per_day prop — keep warning so a recreated product
  // (which changes every variant ID) does not fail silently there too.
  if ((priceMap[tier.ongoingId] ?? priceMap[String(tier.ongoingId)]) == null) {
    console.warn('[lpr] ongoing price not found for variantId:', tier.ongoingId);
  }
}

// Mirrors the quiz's buildResultsLink so the profile's lp_results_url* stay valid when this page
// rewrites the profile (the update middleware REPLACES properties, so this write must be complete).
// Both links carry the identical ?qa= payload — the only difference is where it lands. The
// results page renders the plan and waits for a click; the checkout page skips straight to the
// cart. Keep them building from one function so a field added to the quiz reaches both.
function buildPlanLink(path, ans, discountOverride) {
  const discountCode = discountOverride || ans.discountCode || localStorage.getItem('longevityDiscountCode') || '';
  const payload = {
    name: ans.name || '', gender: ans.gender || '', neutered: ans.neutered || '',
    allergies: ans.allergies || [], weight: ans.weight || '', age: ans.age || '',
    activity: ans.activity || '', appetite: ans.appetite || '', goal: ans.goal || '',
    email: ans.email || '', isCompleted: true, discountCode,
    // WEB-334: keep the quiz's id, so a purchase made from the link links to the lead.
    ...(ans.submissionId ? { submissionId: ans.submissionId } : {}),
  };
  const encoded = btoa(String.fromCharCode(...new TextEncoder().encode(JSON.stringify(payload))));
  const url = new URL(path, window.location.origin);
  url.searchParams.set('qa', encoded);
  if (discountCode) url.searchParams.set('discount', discountCode);
  return url.toString();
}

function buildResultsLink(ans, discountOverride) {
  return buildPlanLink(RESULTS_URL, ans, discountOverride);
}

function buildCheckoutLink(ans, discountOverride) {
  return buildPlanLink(CHECKOUT_URL, ans, discountOverride);
}

// The link properties the profile carries: a plan link and a direct-to-checkout link at each
// discount tier the escalation flows offer, so a flow can swap one for the other on its own.
function buildLinkProps(ans) {
  return {
    lp_results_url: buildResultsLink(ans),
    lp_results_url_10: buildResultsLink(ans, 'LONGEVITY10'),
    lp_results_url_20: buildResultsLink(ans, 'LONGEVITY20'),
    lp_results_url_30: buildResultsLink(ans, 'LONGEVITY30'),
    lp_checkout_url: buildCheckoutLink(ans),
    lp_checkout_url_10: buildCheckoutLink(ans, 'LONGEVITY10'),
    lp_checkout_url_20: buildCheckoutLink(ans, 'LONGEVITY20'),
    lp_checkout_url_30: buildCheckoutLink(ans, 'LONGEVITY30'),
  };
}

async function init() {
  // Set by the direct-to-checkout page (templates/page.longevity_plan_checkout.liquid), which
  // loads this same script so the plan is resolved from one place. Everything up to the Klaviyo
  // side effects runs identically; only the rendering is skipped and the cart is built on load.
  const autoCheckout = !!window.__lprAutoCheckout;
  const qaParam = new URLSearchParams(window.location.search).get('qa');
  if (qaParam) {
    try {
      const decoded = JSON.parse(new TextDecoder().decode(Uint8Array.from(atob(qaParam), c => c.charCodeAt(0))));
      const backfilled = decoded ? backfillAnswers(decoded) : null;
      if (backfilled) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          value: backfilled,
          expiry: Date.now() + 14 * 24 * 60 * 60 * 1000,
        }));
        if (backfilled.discountCode) setDiscountIfBetter(backfilled.discountCode);
      } else {
        // Required field missing — send back to quiz
        window.location.href = QUIZ_URL;
        return;
      }
      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete('qa');
      history.replaceState(null, '', cleanUrl.toString());
    } catch (e) {
      console.warn('[lpr] failed to decode qa param', e);
    }
  }

  const answers = loadAnswers();

  if (!answers || !answers.isCompleted) {
    window.location.href = QUIZ_URL;
    return;
  }

  // Subscribe to ES Marketing Subscribers list via Klaviyo client API
  if (answers.email) {
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=YsjR5W', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: answers.email } } },
          },
          relationships: {
            list: { data: { type: 'list', id: 'T5kRpk' } },
          },
        },
      }),
    }).catch(() => {});
  }

  // Detect LONGEVITY codes applied via /discount/CODE Shopify URLs (3s timeout)
  //
  // Skipped on the checkout page, where this probe is the only thing standing between the click
  // and the redirect and buys nothing: __lprAddToCart runs the same probe itself and recomputes
  // the code it sends, so the cart is charged the same either way. All that changes is the
  // percent written as lp_discount_code — and only for a visitor whose browser already holds a
  // cart-applied code better than the one on their own link.
  let cartCode = null;
  if (!autoCheckout) {
    try {
      const cart = await Promise.race([
        fetch('/cart.js').then(r => r.json()),
        new Promise((_, reject) => setTimeout(() => reject(new Error('timeout')), 3000)),
      ]);
      cartCode = (cart.discount_codes || [])
        .map(d => (d.code || '').toUpperCase())
        .find(c => isKnownDiscountCode(c)) || null;
      if (cartCode) setDiscountIfBetter(cartCode);
    } catch (e) { console.warn('[lpr] cart.js fetch failed/timeout', e); }
  }

  const discount = getActiveDiscount(cartCode, answers);
  window.__lprDiscount = discount.percent;
  // The checkout page carries none of this markup — it redirects before anything could be
  // seen — so it skips straight to the Klaviyo side effects and the cart.
  if (!autoCheckout) {
    if (discount.percent > 0) {
      document.body.classList.add('lpr-discount-active');
      document.querySelectorAll('[data-lpr-discount-badge]').forEach(el => {
        el.textContent = `-${discount.percent}% DTO`;
        el.removeAttribute('hidden');
      });
    }

    fillName(answers);
    fillPortion(answers);
    fillPrices(answers);
    fillFreshAccordions();
  }

  // Hoisted out of the block below so the Klaviyo event further down can piggyback it, and built
  // whenever there is an email rather than only when the middleware helper happens to be loaded.
  let kProps = null;

  if (answers.email) {
    const priceMap = window.__lprPriceMap || {};
    const trialDays = window.__lprTrialDays || 15;
    const discountPct = window.__lprDiscount ?? 20;
    const tier = getFreshTier(answers.weight);
    const trialEntry = priceMap[tier.trialId] ?? priceMap[String(tier.trialId)];
    const ongoingEntry = priceMap[tier.ongoingId] ?? priceMap[String(tier.ongoingId)];
    // The update middleware REPLACES the profile's properties, so send the FULL set the quiz wrote
    // (lp_dog_*, lp_results_url*) plus the price props — otherwise this write wipes the rich props.
    kProps = {
      lp_dog_name: answers.name || '',
      lp_dog_gender: answers.gender || '',
      lp_dog_neutered: answers.neutered || '',
      lp_dog_allergies: (answers.allergies || []).filter(a => a !== 'none').join(', ') || 'none',
      lp_dog_weight_kg: answers.weight || '',
      lp_dog_age: answers.age || '',
      lp_dog_activity: answers.activity || '',
      lp_dog_appetite: answers.appetite || '',
      lp_dog_goal: answers.goal || '',
      lp_quiz_completed_at: new Date().toISOString(),
      ...buildLinkProps(answers),
      lp_daily_grams: parseInt(trialEntry?.title) || calcPortionGrams(answers.weight),
      lp_discount_code: discount.code,
    };
    if (trialEntry) {
      // Same derivation as fillPrices (discount the total, then divide) so the email and the
      // results page never show per-day figures a cent apart.
      const fullTotal = trialEntry.subscriptionPrice;
      const total = discountPct > 0 ? discounted(fullTotal, discountPct) : fullTotal;
      kProps.lp_discounted_price_per_day = (Math.round(total / trialDays) / 100).toFixed(2);
    }
    if (ongoingEntry) {
      kProps.lp_ongoing_price_per_day = (Math.round(ongoingEntry.price / 30) / 100).toFixed(2);
    }
    // Silently no-ops when the profile does not exist yet — a lead arriving straight from a link
    // for an email that never ran the quiz. The event below is what covers those.
    if (typeof window.updateKlaviyoProfile === 'function') {
      window.updateKlaviyoProfile(answers.email, kProps).catch(() => {});
    }
  }

  // Anyone arriving on a ?qa= link may never have run the quiz — a plan link sent by support or an
  // AI agent, a forwarded URL, a QA link. Those leads never had the quiz-completed event fired for
  // them, and the PATCH above no-ops while their profile does not exist yet, so they used to end
  // up with a bare profile or none at all. This fires the event with the properties piggybacked on
  // the profile upsert, which lands both atomically and creates the profile if it is new.
  //
  // Deliberately NOT gated on `answers.variant` the way PT is: that gate only ever opened for an
  // A/B or QA link, which is exactly the population that did not need the help. The trade-off is
  // that a lead who did run the quiz and later clicks the lp_results_url in their email fires the
  // metric a second time — see the note in the commit; `unique_id` is the fix if the flow is not
  // set to run once per profile.
  //
  // PT also does a GA4 lead and a backoffice account claim inside its gate; both stay out of here.
  // They would now run on every link open, counting existing customers as new leads and claiming
  // accounts for addresses that never asked.
  if (qaParam && answers.email) {
    fetch('https://a.klaviyo.com/client/events/?company_id=YsjR5W', {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            properties: { ...(kProps || {}), ...(answers.variant ? { variant: answers.variant } : {}) },
            metric: {
              data: {
                type: 'metric',
                attributes: { name: 'LP Quiz Completed - Fresh' },
              },
            },
            // /client/events upserts the profile atomically, so the lp_* props land for a
            // brand-new lead too — without this the profile stayed bare until a second visit gave
            // the updateKlaviyoProfile call above something to patch.
            profile: {
              data: {
                type: 'profile',
                attributes: { email: answers.email, ...(kProps ? { properties: kProps } : {}) },
              },
            },
          },
        },
      }),
    }).catch(() => {});
  }

  // Direct-to-checkout link (Klaviyo emails): the plan is already resolved above, so build the
  // cart and go. Nothing on this page is clickable — the visitor only ever sees the loader.
  if (autoCheckout) {
    try {
      await window.__lprAddToCart(answers);
    } catch (err) {
      // Never leave a dead screen on a link someone opened from an email. The results page
      // rebuilds the same plan from the same answers, and its CTA has its own AJAX-cart
      // fallback, so the visitor still has a way through.
      console.error('[lpr] auto checkout failed, falling back to the results page:', err);
      window.location.href = buildResultsLink(answers);
    }
    return;
  }

  const ctaBtn = document.getElementById('lpr-cta-btn');
  if (ctaBtn) {
    function handleCTA(e) {
      e.preventDefault();
      if (ctaBtn.disabled) return;
      ctaBtn.disabled = true;
      ctaBtn.textContent = 'Añadiendo al carrito...';
      window.__lprAddToCart(answers).catch((err) => {
        console.error('[lpr] addToCart error:', err);
        ctaBtn.disabled = false;
        ctaBtn.textContent = 'Continuar';
      });
    }
    ctaBtn.addEventListener('click', handleCTA);
    ctaBtn.addEventListener('touchend', handleCTA);
  }
}

async function navigateToCheckout(url) {
  try {
    const resolved = await fetch(url, { redirect: 'follow', credentials: 'include' });
    if (resolved && resolved.url && resolved.url !== url) {
      window.location.href = resolved.url;
      return;
    }
  } catch (e) {
    console.warn('[lpr] checkout URL resolve failed:', e);
  }
  window.location.href = url;
}

async function setCartBuyerEmail(email) {
  const diag = { at: new Date().toISOString(), apiVersion: STOREFRONT_API_VERSION };
  try {
    if (!email) { diag.skipped = 'no email'; return; }
    const cart = await fetch('/cart.js').then(r => r.json());
    const token = cart && cart.token;
    diag.hasCartToken = !!token;
    if (!token) return;
    const shopDomain = window.Shopify?.shopDomain || window.location.hostname;
    diag.shopDomain = shopDomain;
    const sfHttp = await fetch(`https://${shopDomain}/api/${STOREFRONT_API_VERSION}/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': 'ed9628c7216b44f56edebc524e5ad2a4',
      },
      body: JSON.stringify({
        query: `mutation cartBuyerIdentityUpdate($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) {
          cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {
            cart { buyerIdentity { email } }
            userErrors { field message }
          }
        }`,
        variables: {
          cartId: `gid://shopify/Cart/${token}`,
          buyerIdentity: { email: email },
        },
      }),
    });
    const sfRes = await sfHttp.json().catch(() => null);
    diag.httpStatus = sfHttp.status;
    diag.graphqlErrors = sfRes?.errors || null;
    diag.userErrors = sfRes?.data?.cartBuyerIdentityUpdate?.userErrors || null;
    diag.emailSetOnCart = !!sfRes?.data?.cartBuyerIdentityUpdate?.cart?.buyerIdentity?.email;
  } catch (e) {
    diag.exception = String((e && e.message) || e);
  } finally {
    try { localStorage.setItem('lpr_buyeridentity_debug', JSON.stringify(diag)); } catch (e2) {}
  }
}

window.__lprAddToCart = async function (answers) {
  const tier = getFreshTier(answers.weight);
  const priceMap = window.__lprPriceMap || {};
  const trialEntry = priceMap[tier.trialId] ?? priceMap[String(tier.trialId)];
  const sellingPlan = trialEntry?.sellingPlanId ?? LOOP_SELLING_PLAN;

  console.log('[lpr] sellingPlan:', sellingPlan, '| trialEntry:', JSON.stringify(trialEntry));

  const dogObject = {
    name: answers.name,
    gender: answers.gender,
    weight: answers.weight,
    breed: '',
    lifeStage: answers.age,
  };
  // WEB-334: which quiz (and which dog of it, always the first in v1) this dog came from, so the
  // purchase links to the lead in barkyn-core.
  if (answers.submissionId) {
    dogObject.additional_info = { quiz_submission_id: answers.submissionId, quiz_dog_index: 0 };
  }
  const dogObjectKlaviyo = [{
    dog1_name: answers.name || '',
    dog1_gender: answers.gender || '',
    dog1_lifestage: answers.age || '',
    dog1_breed: 'unknown',
    dog1_weight: 'unknown',
    dog1_monthly_food_amount: `${answers.weight} kg`,
    dog1_flavour_preference: (answers.allergies || []).includes('chicken') ? 'hypoallergenic' : 'chicken',
    dog1_feeding_habits: '',
    dog1_improve: answers.goal || '',
  }];

  // Detect session discount before clearing cart
  let freshCartCode = null;
  try {
    const existingCart = await fetch('/cart.js').then(r => r.json());
    freshCartCode = (existingCart.discount_codes || [])
      .map(d => (d.code || '').toUpperCase())
      .find(c => isKnownDiscountCode(c)) || null;
    if (freshCartCode) setDiscountIfBetter(freshCartCode);
  } catch (e) {}
  const { code } = getActiveDiscount(freshCartCode, answers);

  const items = [
    {
      id: tier.trialId,
      quantity: 1,
      selling_plan: sellingPlan,
      properties: {
        _dogs: JSON.stringify([dogObject]),
        _dogs_klaviyo: JSON.stringify(dogObjectKlaviyo),
        _subscriptionType: 'monthlySubscription_v1',
      },
    },
    ...TOPPING_VARIANTS,
  ];
  console.log('[lpr] AJAX fallback: adding to cart', JSON.stringify(items.map(i => i.id || i)));
  await fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } });
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items }),
  });
  if (!res.ok) {
    const errBody = await res.json().catch(() => ({}));
    console.error('[lpr] cart add failed:', res.status, errBody);
    throw new Error('cart add failed');
  }
  await setCartBuyerEmail(answers.email);
  await navigateToCheckout(`/checkout?discount=${encodeURIComponent(code)}`);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
